export const routes = {
  home: '/',
  login: '/login',
  create: '/create',
}

export const publicPaths = [routes.login]
